import {Component, forwardRef, Injector, Input} from '@angular/core';
import {AbstractInput} from '../abstract-input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NumberInputComponent)
        }
    ],
    selector: 'vui-number-input',
    styleUrls: ['./number-input.component.scss'],
    templateUrl: './number-input.component.html'
})
export class NumberInputComponent extends AbstractInput {
    @Input() public max: number;
    @Input() public min: number;

    constructor(protected injector: Injector) {
        super(injector);
    }
}
